module.exports = __webpack_public_path__ + "resources/045c02458ce3519f9adebb7c22c1ec9f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/destination.png
// module id = 207
// module chunks = 0